const booleanLikeOptions = [true, false, 'true', 'false', 1, 0];

export function isBooleanLike(value: string | number | boolean): boolean {
    if (typeof value === 'string') {
        value = value.toLowerCase();
    }

    return booleanLikeOptions.includes(value);
}

export function isTrueLike(value: string | number | boolean): boolean {
    if (typeof value === 'string') {
        value = value.toLowerCase();
    }

    return [true, 'true', 1].includes(value);
}

export function parseBooleanLike(value: string | number | boolean): boolean {
    if (typeof value === 'string') {
        value = value.toLowerCase();
    }

    if (isBooleanLike(value) === false) {
        throw new Error('Not a valid boolean-like value');
    }

    return [true, 'true', 1].includes(value);
}
